<template>
	<div class="modal inmodal fade link-generator-modal" tabindex="-1" role="dialog" id="modalPixelSettings">
		<div class="modal-dialog" role="document">
			<div class="modal-content" v-if="!loading">
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h2 class="modal-title" v-text="translations.title"></h2>
                </div>
                <div class="modal-body">
                    
                    <div class="form-group">
                        <label v-text="`${translations.event}:`"></label><span class="event__data" v-text="eventTitle"></span><br>
                        <label v-text="`${translations.url_param}:`"></label><span class="event__data" v-text="event"></span><br><br>
                        <label class="event_description" v-text="eventDescription"></label><br>
                    </div>
                    
                    <div class="form-group">
                        <label for="facebook" v-text="translations.facebook"></label>
                        <input type="text" :class="(facebookValid ? 'is-green' : 'is-red') + ' form-control'" v-model="facebook" id="facebook" :placeholder="`Pixel ID - ${translations.example}: 1484257648798990`"/>
                        <span v-if="facebookValid" v-text="translations.valid" class="is-green"></span>
                        <span v-else v-text="translations.invalid" class="is-red"></span>
                    </div>
                    
                    <div class="form-group">
                        <label for="google_analytics" v-text="translations.google_analytics"></label>
                        <input type="text" v-model="googleAnalytics" :class="(googleAnalyticsValid ? 'is-green' : 'is-red') + ' form-control'" id="google_analytics" :placeholder="`Pixel ID - ${translations.example}: UA-294156619-8, G-JXKHVSYV71`"/>
                        <span v-if="googleAnalyticsValid" v-text="translations.valid" class="is-green"></span>
                        <span v-else v-text="translations.invalid" class="is-red"></span>
                    </div>

                    <div class="form-group">
                        <label for="google_tag_manager" v-text="translations.google_tag_manager"></label>
                        <input type="text" v-model="googleTagManager" :class="(googleTagManagerValid ? 'is-green' : 'is-red') + ' form-control'" id="google_tag_manager" :placeholder="`Pixel ID - ${translations.example}: GTM-PR97GW6`"/>
                       <span v-if="googleTagManagerValid" v-text="translations.valid" class="is-green"></span>
                        <span v-else v-text="translations.invalid" class="is-red"></span>

                    </div>
                    <button class="btn btn-block is-primary btn__normal" @click="save()" :disabled="!canSave">
                         <i class="fa fa-save" aria-hidden="true"></i>
                         {{translations.save}}
                    </button>
                </div>
			</div>
			<div class="modal-content" v-else>
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <br>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import qs from "qs";
export default {
    props: { event: String },
    data() {
        return {
            loadingVisual:  false,
            loadingEvent:   false,
            loadingRequest: false,
            lang: window.lang || 'us',
            url: {
                getModalVisualData: '',
                updateUserEvent: '',
                getEventData: '',
            },
            translations: {},
            eventData:{},
            facebook:'',
            googleAnalytics:'',
            googleTagManager:'',
            facebookValid: true,
            googleAnalyticsValid: true,
            googleTagManagerValid: true,
            eventTitle: '',
            eventDescription: '',

            facebookPattern: '^[0-9]{15,16}$',
            googleAnalyticsPattern: '^UA-[0-9]{6,9}-[0-9]{1,3}$|^G-[A-Z0-9]{10}$',
            googleTagManagerPattern: '^GTM-[A-Z0-9]{7}$',
        };
    },
    methods:{
        initialize : function(){
            this.url.getModalVisualData = `/${this.lang}/office/pixel-events/get-modal-visual-data`;
            this.url.updateUserEvent =  `/${this.lang}/office/pixel-events/update-user-event`;
            this.url.getEventData = `/${this.lang}/office/pixel-events/get-event-data`;

            this.getModalVisualData();
            this.getEventData();
        },
        getModalVisualData : function(){
            let vm = this
            vm.loadingVisual = true
            
            axios
            .get(vm.url.getModalVisualData)
            .then(function(response) {
                if(response.data.success){
                    vm.translations = response.data.translations;
                }
            })
            .catch(function(error) {
                console.log('error', error);
            })
            .finally(function() {
                vm.loadingVisual = false
            });
        },
        getEventData : function(){
            let vm = this
            vm.loadingEvent = true

            axios
            .post(vm.url.getEventData, qs.stringify({event: vm.event}))
            .then(function(response) {
                if(response.data.success){
                    vm.eventTitle = response.data.event.title;
                    vm.eventDescription = response.data.event.description;
                    vm.facebook = response.data.settings.facebook;
                    vm.googleAnalytics = response.data.settings.google_analytics;
                    vm.googleTagManager = response.data.settings.google_tag_manager;
                }
            })
            .catch(function(error) {
                console.log('error', error);
            })
            .finally(function() {
                vm.loadingEvent = false
            });
        },
        save : function(){
            
            let vm = this;

            if(!vm.canSave){
                return;
            }
            
            vm.loadingRequest = true;

            axios
            .post(vm.url.updateUserEvent, qs.stringify({event: vm.event, facebook: vm.facebook, google_tag_manager: vm.googleTagManager, google_analytics: vm.googleAnalytics}))
            .then(function(response) {
                if(response.data.success){
                    alertMsg("success", vm.translations.success);
                    vm.close();                
                }
            })
            .catch(function(error) {
                alertMsg("error", vm.translations.error);
                console.log('error', error);
            })
            .finally(function() {
                vm.loadingRequest = false;
            }); 
        },
        close : function(){
            $('#modalPixelSettings').modal('hide');
        },
    },
    computed: {
        loading: function () {
            return this.loadingVisual || this.loadingEvent || this.loadingRequest;
        },
        canSave(){
            return this.googleAnalyticsValid && this.facebookValid && this.googleTagManagerValid;
        }
    },
    watch:{
        facebook(val){
            if (val !== null && typeof val != 'undefined' && val != ''){
                this.facebookValid = val.match(this.facebookPattern);
            }else{
                this.facebookValid = true;
            } 
        },
        googleTagManager(val){
            if (val !== null && typeof val != 'undefined' && val != ''){
                this.googleTagManagerValid = val.match(this.googleTagManagerPattern);
            }else{
                this.googleTagManagerValid = true;
            } 
        },
        googleAnalytics(val){
            if (val !== null && typeof val != 'undefined' && val != ''){
                this.googleAnalyticsValid = val.match(this.googleAnalyticsPattern);
            }else{
                this.googleAnalyticsValid = true;
            } 
        },
        event(){
            this.initialize();
        }
    }
}
</script>


<style scoped lang="scss">
    .modal-body {
        .form-group{
            span {
                font-size: 13px;
                padding-top: 5px;
                display: block;
                padding-left: 5px;
                text-transform: capitalize;
            }
        }
        .is-red{
            color:red !important;   
        }

        .is-green{
            color:green !important;
        }

        .modal-loader{
            width: 100px;
        }
        
        .event__data{
            font-style: italic !important;
            text-align: justify !important;
            text-transform: none !important;
        }

        .event_description{
            text-align: justify !important;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/pixel-events/settingsModal.vue